<div
  class="ui-card"
  [class.ui-card--elevated]="elevated()"
  [class.ui-card--interactive]="interactive()"
  [class.ui-card--flush]="!padding()"
>
  @if (title() || subtitle()) {
    <header class="ui-card__header">
      <div class="ui-card__heading">
        @if (title()) {
          <h3 class="ui-card__title">{{ title() }}</h3>
        }
        @if (subtitle()) {
          <p class="ui-card__subtitle">{{ subtitle() }}</p>
        }
      </div>
      <div class="ui-card__actions">
        <ng-content select="[card-actions]" />
      </div>
    </header>
  }

  <div class="ui-card__body"><ng-content /></div>

  <ng-content select="[card-footer]" />
</div>
